import * as React from 'react';

import { ITheme } from '@fluentui/react/lib/Styling';

import { AppFullGallery, getAppGalleryStyles, getGalleryWidth } from '@1js/acui-gallery';
import { AppThemeConsumer } from '@1js/acui-theme';

import { AppFontStylesGalleryButton } from '../AppFontStylesGalleryButton';
import { AppFontStylesFullGalleryProps } from './AppFontStylesFullGallery.Props';
import { galleryButtonWidth, getFontStyleGalleryStyles } from './AppFontStylesFullGallery.styles';

export class AppFontStylesFullGallery extends React.PureComponent<AppFontStylesFullGalleryProps, {}> {
  public render() {
    const { columns, defaultWidth, styles, getGalleryButtonComponent } = this.props;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppFullGallery
            {...this.props}
            styles={getAppGalleryStyles(theme, getFontStyleGalleryStyles(theme, styles))}
            getGalleryButtonComponent={getGalleryButtonComponent || AppFontStylesGalleryButton}
            columns={columns}
            defaultWidth={defaultWidth || getGalleryWidth(columns, galleryButtonWidth, styles)}
          />
        )}
      </AppThemeConsumer>
    );
  }
}
